/* vvd-variant-reprice.js — flag poles & accessories fix (24 Sep 2026)
   Page: /products/flag-poles-and-accessories (and any native-variant product whose option is not a
   "Size" and which has no buy-flow block). assets/vv-buy-cards.js, ITORIS config and prices are untouched.
   Four faults, all measured live on 24 Sep before this file existed:
   1. Quantity tiles kept the FIRST variant's prices after a variant change (Cross Base $49 showed
      $65/$130/$195). vv-buy-cards.js only binds its repaint when the option is a Size.
      -> on a real variant switch, blank the tiles, wait for ITORIS's tier rows (.itier_price) to
         update, then call the widget's own window.__vvbcReprice().
   2. No "Total price" line on these products.
      -> add one under the tiles that mirrors the selected tile (typed qty: window.__vvbcPriceFor).
   3. Add To Cart after choosing a quantity or another variant posted a form with no variant id ->
      Shopify 400, blank /cart/add page, nothing added (ITORIS tier-price flow submits the button's
      own form, which has no [name=id] / [name=quantity]).
      -> give that form hidden id + quantity fields just before the click is handled.
   4. Mobile: after a variant change the legacy calculate handler hid the whole Add To Cart block.
      -> keep that block visible on no-buy-flow products only.
   5. (owner request, same day) the product option dropdown now sits ABOVE the quantity tiles.
   6. Desktop showed two "Add To Cart" buttons after a variant change (ITORIS's tier button plus the
      theme-forced original) -> keep ITORIS's button only while it is present.
   No prices are calculated here: every figure is read from ITORIS's tier rows via the tiles, and the
   cart price is still set by ITORIS. */
(function () {
  if (window.__vvdVariantReprice) return;
  window.__vvdVariantReprice = 1;

  function wrapEl() { return document.querySelector('.vvbc'); }
  function tierSig() {
    return [].map.call(document.querySelectorAll('.itier_price[qty][price]'), function (e) {
      return e.getAttribute('qty') + ':' + e.getAttribute('price');
    }).join('|');
  }
  function blankTiles() {
    [].forEach.call(document.querySelectorAll('.vvbc .vvbc-qty .vvbc-qtile'), function (t) {
      var qp = t.querySelector('.vvbc-qp'), qs = t.querySelector('.vvbc-qs');
      if (qp) qp.textContent = '…';
      if (qs) qs.textContent = '';
    });
    paintTotal();
  }

  /* ---------- 1. repaint tiles on a variant change ---------- */
  var pending = null, lastVid = null;
  function onVariantChange() {
    // A quantity-tile click also fires "change" inside variant-selects (ITORIS updates its own
    // fields). Only a real variant switch needs a repaint, so compare the selected variant id once
    // Dawn has updated it.
    setTimeout(function () {
      var vid = currentVariantId();
      if (!vid || vid === lastVid) return;
      lastVid = vid;
      repaintForVariant();
    }, 60);
  }
  function repaintForVariant() {
    if (typeof window.__vvbcReprice !== 'function') return;
    var before = tierSig();
    blankTiles();
    clearInterval(pending);
    var waited = 0, fallbackDone = false;
    function reprice() {
      window.__vvbcReprice();          // widget re-reads .itier_price and repaints tiles + total
      setTimeout(paintTotal, 1400);   // __vvbcReprice paints after its own 1.2s debounce
    }
    pending = setInterval(function () {
      waited += 150;
      // ITORIS re-renders its tier rows ~0.5–1.5s after the variant changes (longer on a slow
      // connection). Repaint as soon as they change. Two variants can legitimately share the same
      // prices, so repaint anyway at 2.5s, and keep watching until 8s for a late ITORIS update.
      if (tierSig() !== before) { clearInterval(pending); reprice(); return; }
      if (!fallbackDone && waited >= 2500) { fallbackDone = true; reprice(); }
      if (waited >= 8000) clearInterval(pending);
    }, 150);
  }
  function bindVariant() {
    var vs = document.querySelector('variant-selects');
    if (!vs) return false;
    if (vs.__vvPaintBound) return true;   // size-card products: vv-buy-cards.js already handles it
    if (vs.__vvdRepriceBound) return true;
    vs.__vvdRepriceBound = 1;
    lastVid = currentVariantId();
    vs.addEventListener('change', onVariantChange, true);
    return true;
  }

  /* ---------- 2. Total price line where the widget has none ---------- */
  function title() {
    var h = document.querySelector('.vvbc-h1, h1');
    return (h && h.textContent.trim()) || 'this product';
  }
  function ensureTotal() {
    var w = wrapEl(); if (!w) return null;
    if (w.querySelector('.vvbc-flow')) return null;               // widget owns its total
    var mine = w.querySelector('.vvd-total');
    if (mine) return mine;
    if (w.querySelector('.vvbc-total')) return null;
    var anchor = w.querySelector('.vvbc-exact') || w.querySelector('.vvbc-qty');
    if (!anchor) return null;
    mine = document.createElement('div');
    mine.className = 'vvbc-total vvd-total';
    mine.innerHTML = '<span>Total price:</span> <b class="vvbc-tp"></b> <em>inc GST</em><div class="vvbc-tsub"></div>';
    anchor.parentNode.insertBefore(mine, anchor.nextSibling);
    return mine;
  }
  function paintTotal() {
    var box = ensureTotal(); if (!box) return;
    var w = wrapEl();
    var tp = box.querySelector('.vvbc-tp'), ts = box.querySelector('.vvbc-tsub');
    var ex = w.querySelector('.vvbc-exact input');
    var on = w.querySelector('.vvbc-qtile.on');
    if (ex && ex.value !== '' && !on) {
      var n = parseInt(ex.value, 10);
      var u = (n > 0 && typeof window.__vvbcPriceFor === 'function') ? window.__vvbcPriceFor(n) : null;
      if (u > 0) { tp.textContent = '$' + (u * n).toFixed(2); ts.textContent = n + ' × ' + title() + ' · $' + u.toFixed(2) + ' per unit'; }
      else { tp.textContent = '—'; ts.textContent = ''; }
      var qn0 = w.querySelector('.vvbc-qnow'); if (qn0 && n > 0) qn0.textContent = n;
      return;
    }
    if (!on) { tp.textContent = ''; ts.textContent = ''; return; }
    var q = ((on.querySelector('b') || {}).textContent || '1').trim();
    var tot = ((on.querySelector('.vvbc-qp') || {}).textContent || '').trim();
    var ea = ((on.querySelector('.vvbc-qs') || {}).textContent || '').trim();
    if (!tot || tot === '…') { tp.textContent = 'Updating…'; ts.textContent = ''; return; }
    var unit = ea ? ea.split('·')[0].replace(/ea/i, '').trim() : tot;
    tp.textContent = tot;
    ts.textContent = q + ' × ' + title() + ' · ' + unit + ' per unit';
    var qn = w.querySelector('.vvbc-qnow'); if (qn) qn.textContent = q;   // "Quantity: n" label
  }
  function bindTotal() {
    var w = wrapEl(); if (!w || w.__vvdTotalBound) return;
    if (!ensureTotal()) return;
    w.__vvdTotalBound = 1;
    w.addEventListener('click', function (e) { if (e.target.closest('.vvbc-qtile')) setTimeout(paintTotal, 80); });
    w.addEventListener('input', function (e) { if (e.target.closest('.vvbc-exact')) setTimeout(paintTotal, 700); });
    w.addEventListener('change', function (e) { if (e.target.closest('.vvbc-exact')) setTimeout(paintTotal, 700); });
    try {
      var qg = w.querySelector('.vvbc-qty');
      if (qg) new MutationObserver(function () { setTimeout(paintTotal, 30); })
        .observe(qg, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class'] });
    } catch (e) {}
    paintTotal();
  }

  /* ---------- 3. Add To Cart form is missing the variant id and quantity ----------
     On these products the visible #AddToCart sits in a form that carries neither [name="id"] nor
     [name="quantity"] (the variant <select name="id"> lives in Shopify's payment-terms form and the
     quantity input sits outside both). Once the customer picks a quantity tile or another variant,
     ITORIS Wholesale Quantity Breaks (window.tpObserver) takes over the button: it asks ITORIS for the
     tier-priced variant, inserts it after every [name="id"] on the page and then submits the button's
     own form - which still has no id, so Shopify answers 400 and the customer lands on a blank
     /cart/add page with nothing in the cart. Measured live 24 Sep: Cross Base + qty 2 -> 400.
     Fix: before any click on the form's submit button, make sure that form holds a hidden
     [name="id"] with the currently selected variant and a hidden [name="quantity"] with the chosen
     quantity. ITORIS then inserts its tier variant inside the right form; the legacy addItem() shim
     also picks both up. No price is set here - ITORIS still decides the tier price. */
  function atcForm() {
    var b = document.getElementById('AddToCart');
    return b ? b.closest('form[action*="/cart/add"]') : null;
  }
  function currentVariantId() {
    var s = document.getElementById('productSelect') || document.querySelector('select[name="id"], input[name="id"]');
    return s && s.value ? s.value : null;
  }
  function chosenQty() {
    var w = wrapEl();
    var ex = w && w.querySelector('.vvbc-exact input');
    var on = w && w.querySelector('.vvbc-qtile.on b');
    if (ex && ex.value !== '' && !on) { var n = parseInt(ex.value, 10); if (n > 0) return n; }
    if (on) { var m = parseInt(on.textContent, 10); if (m > 0) return m; }
    var g = parseInt(window.__vvbcQty, 10); if (g > 0) return g;
    var qi = document.querySelector('input[name="quantity"]:not(.vvd-hidden-qty)');
    var v = qi ? parseInt(qi.value, 10) : 0;
    return v > 0 ? v : 1;
  }
  function noBuyFlow() { var w = wrapEl(); return !!(w && !w.querySelector('.vvbc-flow')); }
  function ensureFormFields() {
    if (!noBuyFlow()) return;                 // DPO / buy-flow products: their own add path, untouched
    var f = atcForm(); if (!f) return;
    var vid = currentVariantId();
    var own = f.querySelector('input.vvd-hidden-id');
    if (vid && (own || !f.querySelector('[name="id"]'))) {
      if (!own) { own = document.createElement('input'); own.type = 'hidden'; own.name = 'id'; own.className = 'vvd-hidden-id'; f.appendChild(own); }
      if (own.name === 'id') own.value = vid;   // ITORIS renames it to id_prev while it works; leave that alone
    }
    var q = chosenQty();
    var oq = f.querySelector('input.vvd-hidden-qty');
    if (oq || !f.querySelector('[name="quantity"]')) {
      if (!oq) { oq = document.createElement('input'); oq.type = 'hidden'; oq.name = 'quantity'; oq.className = 'vvd-hidden-qty'; f.appendChild(oq); }
      oq.value = q;
    }
    // keep every quantity field in step so ITORIS reads the same number whichever one it finds first
    [].forEach.call(document.querySelectorAll('input[name="quantity"]'), function (i) { if (String(i.value) !== String(q)) i.value = q; });
  }
  /* ---------- 4. Mobile: the Add To Cart block disappears after a variant change ----------
     On mobile, vv-cro-main.js runs a silent "calculate" after a variant change, and the legacy
     calculate handler in product.js adds .hidden to .wraper-form (the old step-2 quote flow). On
     products with no buy-flow (hardware) that wrapper IS the Add To Cart block, so the customer is
     left with no button at all. Keep it visible on those products only. */
  function keepAtcVisible() {
    var w = wrapEl();
    if (!w || w.querySelector('.vvbc-flow')) return;            // DPO/buy-flow products: untouched
    var b = document.getElementById('AddToCart'); if (!b) return;
    var box = b.closest('.wraper-form');
    var form = b.closest('form');
    if (!box || box.__vvdKeep) return;
    box.__vvdKeep = 1;
    var fix = function () {
      if (box.classList.contains('hidden')) box.classList.remove('hidden');
      if (form && form.style.display === 'none') form.style.display = '';
      dedupeAtc();
    };
    /* After a variant change ITORIS Wholesale Quantity Breaks clones #AddToCart (its tier-price
       button) and hides the original, but the theme forces the original visible with !important,
       so desktop showed two identical "Add To Cart" buttons. Keep ITORIS's button (it applies the
       tier price) and hide the legacy one - only while ITORIS's button is present and visible. */
    function dedupeAtc() {
      var all = [].slice.call(document.querySelectorAll('#AddToCart'));
      if (all.length < 2) return;
      var itoris = all.filter(function (x) { return /tpObserver/.test(x.getAttribute('onclick') || ''); })[0];
      if (!itoris) return;
      all.forEach(function (x) {
        if (x !== itoris && /addItem/.test(x.getAttribute('onclick') || '') && x.style.getPropertyValue('display') !== 'none') {
          x.style.setProperty('display', 'none', 'important');
        }
      });
    }
    fix();
    try {
      var mo = new MutationObserver(fix);
      mo.observe(box, { attributes: true, attributeFilter: ['class'] });
      if (form) mo.observe(form, { attributes: true, attributeFilter: ['style'], childList: true, subtree: true });
    } catch (e) {}
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('#AddToCart')) ensureFormFields();
  }, true);
  document.addEventListener('submit', function (e) {
    if (e.target && e.target === atcForm()) ensureFormFields();
  }, true);

  /* ---------- 5. Put the product option first (owner request, 24 Sep 2026) ----------
     On no-buy-flow products the native option dropdown (e.g. "Flag Hardware Only") rendered BELOW
     the quantity tiles, so customers picked a quantity before choosing what they were buying. Move
     the whole <variant-selects> element (Dawn's own element; its selects stay inside it so Dawn's
     variant JS keeps working - vv-buy-cards.js moves it the same way on other products) to the top
     of the buy panel, above "Quantity". Only when it holds a visible option select. */
  function optionsFirst() {
    var w = wrapEl();
    if (!w || w.querySelector('.vvbc-flow') || w.__vvdOptsFirst) return;
    var vs = document.querySelector('variant-selects');
    if (!vs || vs.closest('.vvbc')) return;
    var hasOpt = [].some.call(vs.querySelectorAll('select[name^="options["]'), function (s) { return s.options.length > 1; });
    if (!hasOpt) return;
    var anchor = w.querySelector('.vvbc-qlabel') || w.querySelector('.vvbc-qty');
    if (!anchor) return;
    w.__vvdOptsFirst = 1;
    vs.classList.add('vvd-opts-first');
    anchor.parentNode.insertBefore(vs, anchor);
  }

  var tries = 0, iv = setInterval(function () {
    var ready = wrapEl() && document.querySelector('.vvbc .vvbc-qtile');
    if (ready) {
      var ok = bindVariant();
      bindTotal();
      keepAtcVisible();
      optionsFirst();
      if (ok) { clearInterval(iv); return; }
    }
    if (++tries > 120) clearInterval(iv);
  }, 250);
})();
